module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Our Portfolio")]), _vm._v(" "), _c('div', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "portfolio"
  }, [_c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/mcallen_firestation.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/stabilizing_ocelot_crossings_FM_106.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/apartment_rehabilitation.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/sci_tech_palm_transplant.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/hand_palm_planting_NISSAN.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/texas_persimmon.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/planting_palm.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/sourcing_large_palm.jpg"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26dd10ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Portfolio.vue
// module id = 152
// module chunks = 1